import { getCookie, eraseCookie } from "./cookies";

export const getUserToken = () => getCookie("access_token") || localStorage.getItem("access_token");

export const getUserInfo = () => {
  const cookieInfo = getCookie("user_info");
  if (cookieInfo) {
    try {
      return JSON.parse(decodeURIComponent(cookieInfo));
    } catch (e) {
      console.error("Error parsing user_info cookie", e);
    }
  }
  const localInfo = localStorage.getItem("user_info");
  return localInfo ? JSON.parse(localInfo) : null;
};

export const deleteUserInfo = () => {
  // Preserve user-specific creation dates and reminder settings during logout
  // First, get all keys in localStorage
  const keysToPreserve = Object.keys(localStorage).filter(key => 
    key.startsWith('user_creation_date_') || 
    key.startsWith('user_creation_timestamp_') ||
    key.startsWith('profile_reminder_shown_') ||
    key.startsWith('last_reminder_check_') ||
    key === 'lastUsersDataToRememberLastAccounts' ||
    key === 'pending_token_tag' ||
    key === 'pending_token_slug' ||
    key === 'has_pending_token_tag'
  );
  
  // Store values we want to keep
  const preservedValues = {};
  keysToPreserve.forEach(key => {
    preservedValues[key] = localStorage.getItem(key);
  });

  // Clear everything
  localStorage.clear();
  
  // Clear cookies
  eraseCookie("access_token");
  eraseCookie("user_info");
  
  // Restore preserved values
  Object.keys(preservedValues).forEach(key => {
    localStorage.setItem(key, preservedValues[key]);
  });
};

export const getClientId = () => localStorage.getItem("client_id");